// Suppresses Chrome's PWA install pop-up on the public training pages.
//
// BowVue is installable (site.webmanifest + service worker), so Android Chrome
// volunteers an install prompt on its own. Exam takers arrive by QR code, are
// not staff, and read that dialog as "BowVue requires access to other apps",
// several reported it as exactly that. Suppressing the event on /training/*
// keeps the exam page prompt-free while leaving the PWA install available
// everywhere staff actually work.
//
// (For anyone who already installed, Android's own "open in app?" link chooser
// can still appear on a QR scan, that dialog belongs to the OS and cannot be
// suppressed from the page.)

// Route prefixes where the install prompt must never appear: the public,
// QR-reachable pages.
const SUPPRESSED_PREFIXES = ['/training']

// Whether a pathname is on a suppressed route. Exported for tests.
export function suppressesInstallPrompt(pathname) {
  return SUPPRESSED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  )
}

// beforeinstallprompt listener. Takers land on /training/* via a full page
// load (QR code), so the location at event time is the page being viewed,
// no need to track SPA navigation afterwards.
export function installPromptHandler(event) {
  if (suppressesInstallPrompt(window.location.pathname)) {
    event.preventDefault()
  }
}

export function registerInstallPromptSuppression() {
  window.addEventListener('beforeinstallprompt', installPromptHandler)
}
